import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {
        this.$tables =  this.el.querySelectorAll("table")

        if(this.$tables.length > 0) {
            this.$tables.forEach(($table) => {
                const table = $table;
                const wrapper =  document.createElement('div')

                wrapper.classList.add('o-wysiwyg_table')

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            })
        }
    }
}
